import React, { useEffect, useMemo, useState } from 'react'
import { AutoComplete, Spin } from 'antd'
import {
  fetchPastTopupSchemeKeys,
  mergeTopupSchemeKeyOptions
} from '../utils/fetchPastTopupSchemeKeys'

/**
 * 儲值活動名稱：可手動輸入，亦可從下拉選擇店內曾用過的活動（來自儲值記錄）。
 */
export default function TopupSchemeKeyInput ({
  businessId,
  value,
  onChange,
  placeholder = '可輸入或從下拉選擇曾用過的儲值活動',
  extraSchemeKeys = [],
  disabled,
  style
}) {
  const [loading, setLoading] = useState(false)
  const [apiKeys, setApiKeys] = useState([])

  useEffect(() => {
    if (!businessId) return
    let cancelled = false
    setLoading(true)
    fetchPastTopupSchemeKeys(businessId)
      .then((keys) => {
        if (!cancelled) setApiKeys(keys)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [businessId])

  const options = useMemo(() => {
    const keys = mergeTopupSchemeKeyOptions(apiKeys, extraSchemeKeys)
    return keys.map((k) => ({ value: k, label: k }))
  }, [apiKeys, extraSchemeKeys])

  return (
    <AutoComplete
      style={{ width: '100%', ...style }}
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      allowClear
      disabled={disabled}
      notFoundContent={loading ? <Spin size='small' /> : null}
      filterOption={(inputValue, option) =>
        String(option?.value ?? '')
          .toLowerCase()
          .includes(String(inputValue ?? '').toLowerCase())
      }
    />
  )
}
